import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import y from 'y4/Utils';
import Hoverbox from 'components/common/Hoverbox';
import Image from 'react-bootstrap/Image';
import defaultImage from 'assets/img/illustrations/authentication-corner.png';
import wx from 'weixin-js-sdk';
import { isWeiXinBrowser } from 'y4/WeiXin';

function ImageUpload({ field, name, onChange }) {
  const [image, setImage] = useState(defaultImage);
  const dataType = y.gpv(field, 'other.image.dataType');

  /** Show choose image file and raise onChange
   * @param {*} files
   * @returns
   */
  const handleAddAttachment = files => {
    if (files.length === 0) return;
    const reader = new FileReader();
    reader.onload = function (e) {
      setImage(e.target.result);
    };
    reader.readAsDataURL(files[0]);
    onChange({ name, value: files[0] });
  };

  /** Using wx function to select file then tran to base64 string
   */
  const wxChooseBase64 = () => {
    wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: function (res) {
        const localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        const localId = localIds[0];
        wx.getLocalImgData({
          localId,
          success: function (res) {
            var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
            let imageBase64 = '';
            if (localData.indexOf('data:image') == 0) {
              //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
              imageBase64 = localData;
            } else {
              //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
              //此时一个正常的base64图片路径就完美生成赋值到img的src中了
              imageBase64 =
                'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
            }
            setImage(imageBase64);
            if (dataType == 'WxResourceServerId') {
              wx.uploadImage({
                localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: function (res) {
                  var serverId = res.serverId; // 返回图片的服务器端ID
                  onChange({ name, value: serverId });
                }
              });
            } else {
              onChange({ name, value: imageBase64 });
            }
          }
        });
      }
    });
  };

  //Ref to the file input
  const fileChoose = useRef(null);

  const onClick = () => {
    if (isWeiXinBrowser() && dataType !== 'File') {
      wxChooseBase64();
    } else {
      fileChoose.current.click();
    }
  };
  const button = y.gpv(field, 'other.image.button');
  const button_description = y.gpv(button, 'description');

  return (
    <>
      <Hoverbox className="rounded-bottom border-bottom border-end border-start ms-0">
        <Image src={image} fluid />
        {button && !field.readonly ? (
          <Hoverbox.Content className="text-center light bg-dark bg-opacity-50 p-5 flex-center">
            <input
              type="file"
              ref={fileChoose}
              style={{ display: 'none' }}
              accept="image/*"
              onChange={({ target }) => handleAddAttachment(target.files)}
            />
            <div>
              {button_description ? (
                <p className="lead text-white">
                  {y.gpv(field, 'other.image.button.description')}
                </p>
              ) : null}
              <Button variant="primary" onClick={onClick}>
                {y.gpv(field, 'other.image.button.title')}
              </Button>
            </div>
          </Hoverbox.Content>
        ) : null}
      </Hoverbox>
    </>
  );
}

ImageUpload.propTypes = {
  dataCode: PropTypes.string,
  field: PropTypes.object,
  name: PropTypes.string,
  row: PropTypes.object, //used to show in grid
  onChange: PropTypes.func
};

export default ImageUpload;
